import { BrowserRouter, Routes, Route } from 'react-router-dom';
import InvitationSystem from './components/InvitationSystem';
import AdminTemplates from './pages/AdminTemplates';
import TemplateEditor from './pages/TemplateEditor';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<InvitationSystem />} />
        <Route path="/admin" element={<AdminTemplates />} />
        <Route path="/admin/edit/:templateId" element={<TemplateEditor />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;